<template>
  <div class="forgot-password-view pa-4">
    <p class="text-h6 mb-2">
      Recuperar senha
    </p>

    <p class="text-caption mb-0">
      Enviaremos um link de recuperação para o email informado.
    </p>

    <forgot-password-form
      :loading="isSendingInfo"
      @submit="(fields) => requestPasswordReset(fields)"
    />
  </div>
</template>

<script>
import store from '@/services/store';

import api from '../utils/guest-api';
import { getLoginFailureOptions } from '../utils/error-utils';

import ForgotPasswordForm from '../components/ForgotPasswordForm.vue';

export default {
  name: 'ForgotPasswordView',

  components: {
    ForgotPasswordForm,
  },

  data: () => ({
    isSendingInfo: false,
  }),

  methods: {
    async requestPasswordReset(fields) {
      this.isSendingInfo = true;

      try {
        await api.auth.requestPasswordReset(fields);

        store.dispatch('alert/showAlert', {
          icon: 'mdi-check',
          iconColor: 'success',
          title: 'Recuperação de senha solicitada',
          message: 'Acesse o link enviado para o email informado e siga as instruções para recuperar sua senha',
        });
      } catch (error) {
        store.dispatch('alert/showAlert', getLoginFailureOptions(error));
      } finally {
        this.isSendingInfo = false;
      }
    },
  },
};
</script>
